/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { DistrictResponseDto } from '../model/districtResponseDto';
import { ProvinceResponseDto } from '../model/provinceResponseDto';
import { SubDistrictResponseDto } from '../model/subDistrictResponseDto';
import { ValidationError } from '../model/validationError';


@Injectable({
  providedIn: 'root',
})
export class MasterDataService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public masterDataDistrictsGet$(name?: string, provinceId?: number, sort?: string): Observable<Array<DistrictResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/master-data/districts`, { name, provinceId, sort });
  }
  /**
   * [Authorize] type: http
   */
  public masterDataProvincesGet$(name?: string, sort?: string): Observable<Array<ProvinceResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/master-data/provinces`, { name, sort });
  }
  /**
   * [Authorize] type: http
   */
  public masterDataSubDistrictsGet$(name?: string, districtId?: number, zipCode?: string, sort?: string): Observable<Array<SubDistrictResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/master-data/sub-districts`, { name, districtId, zipCode, sort });
  }
}
